import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Print from 'apollo-react-icons/Print';
import qs from 'query-string';
import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { setEnhancedModalOpen } from '../../actions/EnhancedModalActions';
import { displayStepForm } from '../../actions/WorkflowStepPageActions';
import { DOCUMENT_VIEWER } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { FORM_KEYS } from '../../form-designer/constants/form-manager.constants';
import { getAllowContentDownload, getAllowControlPrint } from '../../selectors/DocumentViewer';
import { isTrue } from '../../utils/commonUtils';

const useStyles = makeStyles({
  buttonStyle: {
    marginRight: 10,
  },
});

const requestPrintFormData = {
  entityViewName: 'V_SS_PRINT_CTL_JOB',
  entityType: 'SS_PRINT_CTL_JOB',
  containerWorkflowKey: 'SS_PRINT_CTL_JOB_WORKFLOW',
  workflowKey: 'SS_PRINT_CTL_JOB_WORKFLOW_NP_WORKFLOW',
  stepId: 'PrintDocumentRequest',
  itmId: '',
  formKey: 'SS_PRINT_CTL_JOB_DOC_REQUEST',
  entityName: undefined,
  storeKey: FORM_KEYS.MODAL,
  workflowId: '',
};

const requestBatchPrintFormData = {
  entityViewName: 'V_SS_DOC_BATCH_PRINT',
  entityType: 'SS_DOC_BATCH_PRINT',
  containerWorkflowKey: 'SS_DOC_BATCH_PRINT_WORKFLOW',
  workflowKey: 'SS_DOC_BATCH_PRINT_WORKFLOW_NP_WORKFLOW',
  stepId: 'RequestBatchPrintJob',
  itmId: '',
  formKey: 'SS_DOC_BATCH_PRINT_JOB_REQUEST',
  entityName: undefined,
  storeKey: FORM_KEYS.MODAL,
  workflowId: '',
};

export const RequestPrintButton = () => {
  const { pathname, search } = useLocation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const allowControlPrint = useSelector(getAllowControlPrint);
  const allowContentDownload = useSelector(getAllowContentDownload);
  const translateString = useTranslation();

  const isPrintButtonOnly = isTrue(allowControlPrint) && !isTrue(allowContentDownload);
  const showPrintButton = isTrue(allowControlPrint) && pathname === DOCUMENT_VIEWER;

  const { isBatchPrint } = qs.parse(search);
  const stepFormParams = isBatchPrint === 'true' ? requestBatchPrintFormData : requestPrintFormData;

  return (
    showPrintButton && (
      <Button
        icon={Print}
        className={!isPrintButtonOnly ? classes.buttonStyle : null}
        variant="secondary"
        onClick={() => {
          batch(() => {
            dispatch(setEnhancedModalOpen(true));
            dispatch(displayStepForm(stepFormParams));
          });
        }}
      >
        {translateString('Print File')}
      </Button>
    )
  );
};
